    function bundleproductcheckboxtoggle2(checkbox) {
      var subProductsDiv = document.getElementById('subproducts');
      var bundleProductsCheckboxlabeliddiv2 = document.getElementById('bundleProductsCheckboxlabelid2');
      var bagsubproductdiv = document.getElementById('bagsubproduct');
      var topbagaddtocartcontainerdiv = document.querySelector('#topbagaddtocartcontainer');
      var bottombagaddtocartcontainerdiv = document.querySelector('#bottombagaddtocartcontainer');
      var bottombagaddtocartbuttondiv = document.getElementById('bottombagaddToCartButton');
      var topbagaddtocartbuttondiv = document.getElementById('topbagaddToCartButton');
      var baginputField = document.getElementById('properties[BAG NAME]');
      var qtycheckboxcontainerdiv = document.getElementById('qtycheckboxcontainer');
      var bagquantitydisplaydiv = document.getElementById('bagquantity-display');
      var bagquantitydisplaydiv2 = document.getElementById('bagquantity-display2');
      var hidecheckboxiddiv = document.getElementById('hidecheckboxid');
      var bundleProductsCheckbox2 = document.getElementById('bundleProductsCheckbox2');

      if (checkbox.checked) {
        hidecheckboxiddiv.style.display = "none";
        subProductsDiv.style.maxHeight = subProductsDiv.scrollHeight + "px";
        bagsubproductdiv.style.maxHeight = "0";
        topbagaddtocartcontainerdiv.style.maxHeight = '0';
        topbagaddtocartbuttondiv.style.display = "none";
        qtycheckboxcontainerdiv.style.display = "none";
        bagquantitydisplaydiv.textContent = "0";
        bagquantitydisplaydiv2.textContent = "0";
        bundleProductsCheckboxlabeliddiv2.innerHTML = "";
        bundleProductsCheckbox2.style.display = "none"; // Hide the bundleProductsCheckbox2

        // Create and append the new checkboxes with text
        var checkboxAboveSpan = document.createElement('span');
        var checkboxAbove = document.createElement('input');
        checkboxAbove.setAttribute('type', 'checkbox');
        checkboxAbove.checked = true;
        checkboxAbove.style.width = '15px'; // Set the width
        checkboxAbove.style.height = '15px'; // Set the height
        //checkboxAbove.disabled = true;
        checkboxAbove.id = 'checkboxAbove';
        checkboxAbove.onclick = bundleproductcheckboxtoggle2;
        checkboxAboveSpan.appendChild(checkboxAbove);
        checkboxAboveSpan.appendChild(document.createTextNode('CUSTOM NAME ON BAG '));
        bundleProductsCheckboxlabeliddiv2.appendChild(checkboxAboveSpan);
        bundleProductsCheckboxlabeliddiv2.appendChild(document.createElement('br'));

        var dogTagSpan = document.createElement('span');
        var dogTagCheckbox = document.createElement('input');
        dogTagCheckbox.setAttribute('type', 'checkbox');
        dogTagCheckbox.checked = true;
        dogTagCheckbox.style.width = '15px'; // Set the width
        dogTagCheckbox.style.height = '15px'; // Set the height
        //dogTagCheckbox.disabled = true;
        dogTagCheckbox.id = 'dogTagCheckbox';
        dogTagCheckbox.onclick = bundleproductcheckboxtoggle2;
        dogTagSpan.appendChild(dogTagCheckbox);
        dogTagSpan.appendChild(document.createTextNode('12 ID STICKERS FOR BIKE '));
        bundleProductsCheckboxlabeliddiv2.appendChild(dogTagSpan);
        bundleProductsCheckboxlabeliddiv2.appendChild(document.createElement('br'));

        var checkboxBelowSpan = document.createElement('span');
        var checkboxBelow = document.createElement('input');
        checkboxBelow.setAttribute('type', 'checkbox');
        checkboxBelow.checked = true;
        checkboxBelow.style.width = '15px'; // Set the width
        checkboxBelow.style.height = '15px'; // Set the height
        //checkboxBelow.disabled = true;
        checkboxBelow.id = 'checkboxBelow';
        checkboxBelow.onclick = bundleproductcheckboxtoggle2;
        checkboxBelowSpan.appendChild(checkboxBelow);
        checkboxBelowSpan.appendChild(document.createTextNode('PERSONALIZED ID TAG '));
        bundleProductsCheckboxlabeliddiv2.appendChild(checkboxBelowSpan);
      } else {
        hidecheckboxiddiv.style.display = "";
        subProductsDiv.style.maxHeight = "0";
        topbagaddtocartcontainerdiv.style.maxHeight = "100%";
        topbagaddtocartbuttondiv.style.display = "";
        baginputField.value = '';
        qtycheckboxcontainerdiv.style.display = "";
        bagquantitydisplaydiv2.textContent = "0";
        bagquantitydisplaydiv.textContent = "0";
        bundleProductsCheckboxlabeliddiv2.innerHTML = "Click Here To Add Custom Name To Bag + Create Bike Stickers & ID Tag<br> FOR JUST $35";
        bundleProductsCheckbox2.style.display = ""; // Unhide the bundleProductsCheckbox2

        // Remove the added checkboxes when unchecked
        bundleProductsCheckboxlabeliddiv2.innerHTML = 'Click Here To Add Custom Name To Bag + Create Bike Stickers & ID Tag<br> FOR JUST $35';
      }
    }